import '~/components/trip-details-form/trip-details-form';
import { TripDetailsEvent, TripDetailsForm } from '~/components/trip-details-form/trip-details-form';
import { DVGStateManager } from '~/assets/js/state';

class DVGReisDetails {
  private stateManager = new DVGStateManager();
  private tripDetailsFormElement: TripDetailsForm | null = document.querySelector('.dvg-reis-details-formulier');

  constructor() {
    this.prefillTripDetailsForm();
    this.setupListeners();
  }
  prefillTripDetailsForm() {
    if (!this.tripDetailsFormElement) return;

    const urlParams = new URLSearchParams(window.location.search);
    const { arrival, departure } = this.stateManager.getArrivalAndDepartureFromURL();
    const party = this.stateManager.getPartyFromURL();
    const location = urlParams.get('regions') || '';
    const theme = urlParams.get('theme') || '';

    this.tripDetailsFormElement.location = location;
    this.tripDetailsFormElement.theme = theme;
    this.tripDetailsFormElement.startDate = arrival ?? '';
    this.tripDetailsFormElement.endDate = departure ?? '';
    this.tripDetailsFormElement.party = party;
  }

  setupListeners() {
    if (this.tripDetailsFormElement) {
      this.tripDetailsFormElement.addEventListener('dvg:trip-details-change', this.handleTripDetailsChange);
    }
  }

  handleTripDetailsChange = (event: TripDetailsEvent) => {
    if (this.tripDetailsFormElement) {
      this.tripDetailsFormElement.loading = true;
    }

    const { detail } = event;

    let formHasErrors = false;
    if (this.tripDetailsFormElement) {
      this.tripDetailsFormElement.errorMessage = undefined;
      this.tripDetailsFormElement.fieldHasError = undefined;
    }

    if (detail.startDate && detail.endDate) {
      this.stateManager.storeArrivalAndDepartureInURL(detail.startDate, detail.endDate);
    } else {
      this.stateManager.deleteArrivalAndDepartureFromURL();
    }

    if (detail.party) {
      const party = detail.party;

      if ((party.adults === 0 && party.children + party.infants > 0) && this.tripDetailsFormElement) {
        this.tripDetailsFormElement.errorMessage = 'Er moet minimaal 1 volwassene aanwezig zijn.';
        this.tripDetailsFormElement.fieldHasError = 'party';
        formHasErrors = true;
      } else {
        this.stateManager.storePartyInURL(party);
      }
    }

    const additionalParams: Record<string, string> = {};

    if (detail.location) {
      additionalParams['regions'] = detail.location;
    }

    if (detail.theme) {
      additionalParams['tags'] = detail.theme;
    }

    if (!formHasErrors) {
      this.stateManager.navigate('/vakantiehuisjes', additionalParams);
    } else if (this.tripDetailsFormElement) {
      this.tripDetailsFormElement.loading = false;
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new DVGReisDetails();
});
